import gql from 'graphql-tag'

export const courseFragment = gql`
  fragment CourseFragment on Course {
    id
    name
    integrationCourseLink
    participantsCount(areaId: $areaId, ransack: $participantsQuery)
    hours
    state
    progress(areaId: $areaId, ransack: $participantsQuery) {
      finish
      inProgress
      pending
    }
    progressEvaluations(areaId: $areaId, ransack: $participantsQuery) {
      reproved
      approved
      total
    }
    synchronousCourse {
      id
      evaluationsCount
    }
  }
`

export const externalCoursesFragment = gql`
  fragment ExternalCoursesFragment on ExternalCourse {
    id
    name
    code
    institution
    hours
    startDate
    endDate
    participantsCount
    progress {
      finish
      inProgress
      pending
    }
    progressEvaluations {
      reproved
      approved
      total
    }
    certificatesCount
  }
`
